import {Component, OnInit} from '@angular/core';
import {LoginData} from 'app/models/login-data';
import {Router, Params, ActivatedRoute} from '@angular/router';
import {AuthService} from 'app/services/auth.service';
import {environment} from 'environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  rememberMe: boolean;
  redirectURL: string;

  constructor(private router: Router, private auth: AuthService, private route: ActivatedRoute) {
    // this.rememberMe = sessionStorage.getItem('remember-me') === 'true';
    // this.route.queryParamMap.subscribe((params: ParamMap) => this.redirectURL = params.get('redirectURL') || '/competition');
  }

  ngOnInit() {
    if (environment.production) {
      this.route.queryParams.subscribe((params: Params) => {
        if (!params['auth']) {
          this.auth.redirect().subscribe(r => {
            console.log('Called redirect');
          });
        } else {
          this.auth.authentication({ code: params['auth'] }).subscribe(r => {
            this.router.navigate(['competition']);
          });
        }
      });
    } else {
      this.auth.authentication({ code: 'local-env-dev' }).subscribe(r => {
        this.router.navigate(['competition']);
      });
    }
  }

  login(data: LoginData) {
    // TODO login without authentication data - only for testing
    // sessionStorage.setItem('logged-in', 'true');
    // sessionStorage.setItem('remember-me', data.rememberMe ? 'true' : 'false');
    // // TODO END

    // // Start Guide panel after logon
    // sessionStorage.setItem('first-start', 'true');
    // this.router.navigate([this.redirectURL]);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/login/login.component.ts